import '@/shared/assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import VueJsTour from '@globalhive/vuejs-tour'
import '@globalhive/vuejs-tour/dist/style.css'
import i18n from '@/shared/config/i18n'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueJsTour)
app.use(i18n)

app.mount('#app')
